module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1dfe5425b42628b6f1df1f39e97a319f.svg";